
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('overview', {
      data: 'passersby'
    })
  } // computed
}; // export default
